import Vue from "vue";
import VueRouter from "vue-router";
import CustomersView from "../views/CustomersView.vue";
import ProvidersView from "../views/ProvidersView.vue";
import ProviderRequestsView from "../views/Statistics/ProviderRequestsView.vue";
import CustomerSelectedView from "../views/Statistics/CustomerSelectedView.vue";
import LoginView from "../views/LoginView.vue";
import axios from "axios";
import cognitoAuth from "@/cognito";

Vue.use(VueRouter);

function authMiddleware(to, from, next) {
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    if (err) return next();
    if (!loggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  });
}

const routes = [
  {
    path: "/",
    name: "home",
    component: CustomersView,
    alias: "/home",
    beforeEnter: authMiddleware
  },
  {
    path: "/customers",
    name: "customers",
    component: CustomersView,
    beforeEnter: authMiddleware
  },
  {
    path: "/providers",
    name: "providers",
    component: ProvidersView,
    beforeEnter: authMiddleware
  },
  {
    path: "/statistics/providers/requests",
    name: "providerrequests",
    component: ProviderRequestsView,
    beforeEnter: authMiddleware
  },
  {
    path: "/statistics/customers/selected",
    name: "customerselectedbreakdown",
    component: CustomerSelectedView,
    beforeEnter: authMiddleware
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("DiSCToolsToken")) {
        const token = localStorage.getItem("DiSCToolsToken");
        const config = {
          headers: { Authorization: `Bearer ${token}` }
        };
        axios
          .get("https://disctools.co.uk/api/auth/check", config)
          .then(result => {
            if (result.status === 200) {
              next("/home");
            } else {
              next();
            }
          })
          .catch(err => {
            console.log(err);
            next();
          });
      } else {
        next();
      }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
